// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/context/v1/context.proto" (package "agency.context.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Duration } from "../../../google/protobuf/duration";
import { SkillTrustLevel } from "../../skill/v1/skill";
import { IngressPolicyConfig } from "../../config/v1/config";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { Struct } from "../../../google/protobuf/struct";
/**
 * ContextBundle is the output of the context pipeline.
 *
 * @generated from protobuf message agency.context.v1.ContextBundle
 */
export interface ContextBundle {
    /**
     * tenant is the tenant this context belongs to.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace this context belongs to.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * system_prompt is the assembled system instruction.
     *
     * @generated from protobuf field: string system_prompt = 3
     */
    systemPrompt: string;
    /**
     * prompts are global prompts from KV store (merged into context).
     *
     * @generated from protobuf field: map<string, string> prompts = 12
     */
    prompts: {
        [key: string]: string;
    };
    /**
     * skills are injectable context blocks matched to this workspace.
     *
     * @generated from protobuf field: repeated agency.context.v1.ContextSkill skills = 4
     */
    skills: ContextSkill[];
    /**
     * artifacts are references to workspace artifacts (RAG corpora, etc).
     *
     * @generated from protobuf field: repeated agency.context.v1.ArtifactReference artifacts = 5
     */
    artifacts: ArtifactReference[];
    /**
     * workspace_config contains workspace-specific configuration.
     *
     * @generated from protobuf field: map<string, string> workspace_config = 6
     */
    workspaceConfig: {
        [key: string]: string;
    };
    /**
     * thread_seed is thread-context KV data (merged into context).
     *
     * @generated from protobuf field: map<string, string> thread_seed = 13
     */
    threadSeed: {
        [key: string]: string;
    };
    /**
     * thread_seed_context is the thread-level context (if applicable).
     *
     * @generated from protobuf field: string thread_seed_context = 7
     */
    threadSeedContext: string;
    /**
     * model_params are model-specific parameters.
     *
     * @generated from protobuf field: google.protobuf.Struct model_params = 8
     */
    modelParams?: Struct;
    /**
     * allowed_tools are workspace-permitted (tool, location) pairs (empty = all allowed).
     * Each entry specifies a tool name and an optional provider location.
     * Empty location = all locations for that tool name are permitted.
     *
     * @generated from protobuf field: repeated agency.context.v1.AllowedTool allowed_tools = 9
     */
    allowedTools: AllowedTool[];
    /**
     * updated_at is when this bundle was assembled.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 10
     */
    updatedAt?: Timestamp;
    /**
     * revision is the bundle revision for change tracking (NATS KV sequence).
     *
     * @generated from protobuf field: uint64 revision = 11
     */
    revision: bigint;
    /**
     * cache_key is the content fingerprint from the contextualizer assembler.
     * Rolling SHA-256 over all layer content+version pairs in stable assembly order.
     * Same content at different revision numbers → same cache_key (no spurious invalidation).
     *
     * @generated from protobuf field: string cache_key = 14
     */
    cacheKey: string;
    /**
     * cache_boundaries are per-layer byte offsets and cumulative content hashes
     * produced by the contextualizer assembler. Used by provider-specific LLM clients
     * to inject cache-control markers at the correct message boundaries.
     *
     * @generated from protobuf field: repeated agency.context.v1.CacheBoundary cache_boundaries = 15
     */
    cacheBoundaries: CacheBoundary[];
    /**
     * provider_hints carries provider-specific cache optimization metadata
     * derived from cache_boundaries by the contextualizer assembler.
     *
     * @generated from protobuf field: agency.context.v1.ProviderHints provider_hints = 16
     */
    providerHints?: ProviderHints;
    /**
     * ingress_policy configures concurrent ingress handling for this workspace.
     * Required — sessions fail-fast at startup if absent.
     *
     * @generated from protobuf field: agency.config.v1.IngressPolicyConfig ingress_policy = 17
     */
    ingressPolicy?: IngressPolicyConfig;
}
/**
 * AllowedTool is a (name, location) predicate for the workspace tool allowlist.
 * name: tool name — required, must satisfy tool name pattern.
 * location: provider location label — optional; empty = permit any location for this tool.
 *
 * @generated from protobuf message agency.context.v1.AllowedTool
 */
export interface AllowedTool {
    /**
     * name is the tool name (required).
     *
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * location is the provider location label (optional; empty = any location).
     *
     * @generated from protobuf field: string location = 2
     */
    location: string;
}
/**
 * ScopeAssemblyConfig defines the layer topology for all context scopes
 * (tenant, workspace, conversation, session) for a given workspace.
 *
 * Stored as proto-JSON in the workspace config KV bucket
 * (context_{tenant}_{workspace}) under the well-known key "ctx_scope_config".
 * Read by the context-service on workspace discovery.
 *
 * Assembly order (stable → volatile):
 *   tenant layers → workspace layers → conversation layers → session layers
 *
 * All layer IDs across all scopes must be globally distinct.
 *
 * @generated from protobuf message agency.context.v1.ScopeAssemblyConfig
 */
export interface ScopeAssemblyConfig {
    /**
     * tenant defines layer topology for tenant-scoped atoms.
     *
     * @generated from protobuf field: agency.context.v1.ScopeLayerConfig tenant = 1
     */
    tenant?: ScopeLayerConfig;
    /**
     * workspace defines layer topology for workspace-scoped atoms.
     *
     * @generated from protobuf field: agency.context.v1.ScopeLayerConfig workspace = 2
     */
    workspace?: ScopeLayerConfig;
    /**
     * conversation defines layer topology for conversation-scoped atoms.
     * Optional — omit if conversation-scope assembly is not used.
     *
     * @generated from protobuf field: agency.context.v1.ScopeLayerConfig conversation = 3
     */
    conversation?: ScopeLayerConfig;
    /**
     * session defines layer topology for session-scoped atoms.
     * Optional — omit if session-scope assembly is not used.
     *
     * @generated from protobuf field: agency.context.v1.ScopeLayerConfig session = 4
     */
    session?: ScopeLayerConfig;
}
/**
 * ScopeLayerConfig defines the ordered layer set for a single scope level.
 *
 * @generated from protobuf message agency.context.v1.ScopeLayerConfig
 */
export interface ScopeLayerConfig {
    /**
     * layers is the ordered list of layer IDs, most stable first.
     * Must be non-empty when this scope is active.
     *
     * @generated from protobuf field: repeated string layers = 1
     */
    layers: string[];
    /**
     * volatile_layers lists layer IDs excluded from the stable prefix calculation.
     * Must be a non-empty subset of layers when this scope is active.
     *
     * @generated from protobuf field: repeated string volatile_layers = 2
     */
    volatileLayers: string[];
}
/**
 * ContextAtomOp is the request sent by a context-provider to the harness
 * over core NATS req/reply (subject: context.atom.<tenant>.<workspace>).
 * The harness executes the operation against JetStream KV and replies ContextAtomResult.
 * scope_id is required for conversation and session scopes; omit for workspace scope.
 *
 * @generated from protobuf message agency.context.v1.ContextAtomOp
 */
export interface ContextAtomOp {
    /**
     * @generated from protobuf oneof: op
     */
    op: {
        oneofKind: "putSegment";
        /**
         * @generated from protobuf field: agency.context.v1.PutSegmentOp put_segment = 1
         */
        putSegment: PutSegmentOp;
    } | {
        oneofKind: "deleteSegment";
        /**
         * @generated from protobuf field: agency.context.v1.DeleteSegmentOp delete_segment = 2
         */
        deleteSegment: DeleteSegmentOp;
    } | {
        oneofKind: "putWsConfig";
        /**
         * @generated from protobuf field: agency.context.v1.PutWsConfigOp put_ws_config = 3
         */
        putWsConfig: PutWsConfigOp;
    } | {
        oneofKind: "putScopeConfig";
        /**
         * @generated from protobuf field: agency.context.v1.PutScopeConfigOp put_scope_config = 4
         */
        putScopeConfig: PutScopeConfigOp;
    } | {
        oneofKind: "publishTrigger";
        /**
         * @generated from protobuf field: agency.context.v1.PublishTriggerOp publish_trigger = 5
         */
        publishTrigger: PublishTriggerOp;
    } | {
        oneofKind: "getSegment";
        /**
         * @generated from protobuf field: agency.context.v1.GetSegmentOp get_segment = 6
         */
        getSegment: GetSegmentOp;
    } | {
        oneofKind: "getWsConfig";
        /**
         * @generated from protobuf field: agency.context.v1.GetWsConfigOp get_ws_config = 7
         */
        getWsConfig: GetWsConfigOp;
    } | {
        oneofKind: "setSessionModel";
        /**
         * @generated from protobuf field: agency.context.v1.SetSessionModelOp set_session_model = 8
         */
        setSessionModel: SetSessionModelOp;
    } | {
        oneofKind: "getSessionModel";
        /**
         * @generated from protobuf field: agency.context.v1.GetSessionModelOp get_session_model = 9
         */
        getSessionModel: GetSessionModelOp;
    } | {
        oneofKind: undefined;
    };
}
/**
 * ContextAtomResult is the harness reply to a ContextAtomOp request.
 *
 * @generated from protobuf message agency.context.v1.ContextAtomResult
 */
export interface ContextAtomResult {
    /**
     * @generated from protobuf oneof: result
     */
    result: {
        oneofKind: "mutation";
        /**
         * @generated from protobuf field: agency.context.v1.MutationResult mutation = 1
         */
        mutation: MutationResult; // put_segment, delete_segment, put_ws_config, put_scope_config, publish_trigger, set_session_model
    } | {
        oneofKind: "segment";
        /**
         * @generated from protobuf field: agency.context.v1.GetSegmentResult segment = 2
         */
        segment: GetSegmentResult; // get_segment
    } | {
        oneofKind: "wsConfig";
        /**
         * @generated from protobuf field: agency.context.v1.GetWsConfigResult ws_config = 3
         */
        wsConfig: GetWsConfigResult; // get_ws_config
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: string error = 4
         */
        error: string; // any op on failure
    } | {
        oneofKind: "sessionModel";
        /**
         * @generated from protobuf field: agency.context.v1.GetSessionModelResult session_model = 5
         */
        sessionModel: GetSessionModelResult; // get_session_model
    } | {
        oneofKind: undefined;
    };
}
/**
 * MutationResult is returned for write and publish operations.
 *
 * @generated from protobuf message agency.context.v1.MutationResult
 */
export interface MutationResult {
    /**
     * @generated from protobuf field: uint64 revision = 1
     */
    revision: bigint; // KV revision after put; 0 for delete and trigger
}
/**
 * GetSegmentResult carries the retrieved segment atom.
 *
 * @generated from protobuf message agency.context.v1.GetSegmentResult
 */
export interface GetSegmentResult {
    /**
     * @generated from protobuf field: string layer = 1
     */
    layer: string;
    /**
     * @generated from protobuf field: string vertical = 2
     */
    vertical: string;
    /**
     * @generated from protobuf field: string content = 3
     */
    content: string;
    /**
     * @generated from protobuf field: string version = 4
     */
    version: string;
}
/**
 * GetWsConfigResult carries the retrieved workspace config value.
 *
 * @generated from protobuf message agency.context.v1.GetWsConfigResult
 */
export interface GetWsConfigResult {
    /**
     * @generated from protobuf field: string key = 1
     */
    key: string;
    /**
     * @generated from protobuf field: string value = 2
     */
    value: string;
}
/**
 * GetSessionModelResult carries the retrieved per-session model_id override.
 *
 * @generated from protobuf message agency.context.v1.GetSessionModelResult
 */
export interface GetSessionModelResult {
    /**
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * @generated from protobuf field: string model_id = 2
     */
    modelId: string; // empty when no override is set
}
/**
 * PutSegmentOp writes one atom. scope_type: "workspace"|"conversation"|"session".
 * scope_id required for conversation and session; omit for workspace.
 *
 * @generated from protobuf message agency.context.v1.PutSegmentOp
 */
export interface PutSegmentOp {
    /**
     * @generated from protobuf field: string scope_type = 1
     */
    scopeType: string; // "workspace" | "conversation" | "session"
    /**
     * @generated from protobuf field: string scope_id = 2
     */
    scopeId: string; // conversation or session ID; empty for workspace
    /**
     * @generated from protobuf field: string layer = 3
     */
    layer: string;
    /**
     * @generated from protobuf field: string vertical = 4
     */
    vertical: string;
    /**
     * @generated from protobuf field: string content = 5
     */
    content: string;
    /**
     * @generated from protobuf field: string version = 6
     */
    version: string;
}
/**
 * DeleteSegmentOp deletes one atom key.
 *
 * @generated from protobuf message agency.context.v1.DeleteSegmentOp
 */
export interface DeleteSegmentOp {
    /**
     * @generated from protobuf field: string scope_type = 1
     */
    scopeType: string;
    /**
     * @generated from protobuf field: string scope_id = 2
     */
    scopeId: string;
    /**
     * @generated from protobuf field: string layer = 3
     */
    layer: string;
    /**
     * @generated from protobuf field: string vertical = 4
     */
    vertical: string;
}
/**
 * PutWsConfigOp writes one workspace config key/value.
 *
 * @generated from protobuf message agency.context.v1.PutWsConfigOp
 */
export interface PutWsConfigOp {
    /**
     * @generated from protobuf field: string key = 1
     */
    key: string;
    /**
     * @generated from protobuf field: string value = 2
     */
    value: string;
}
/**
 * PutScopeConfigOp writes the ScopeAssemblyConfig as proto-JSON to ctx_scope_config.
 *
 * @generated from protobuf message agency.context.v1.PutScopeConfigOp
 */
export interface PutScopeConfigOp {
    /**
     * @generated from protobuf field: agency.context.v1.ScopeAssemblyConfig scope_config = 1
     */
    scopeConfig?: ScopeAssemblyConfig;
}
/**
 * PublishTriggerOp publishes a ContextBuildTrigger to force re-assembly.
 *
 * @generated from protobuf message agency.context.v1.PublishTriggerOp
 */
export interface PublishTriggerOp {
    /**
     * @generated from protobuf field: string reason = 1
     */
    reason: string;
    /**
     * @generated from protobuf field: string conversation_id = 2
     */
    conversationId: string; // optional
    /**
     * @generated from protobuf field: string session_id = 3
     */
    sessionId: string; // optional
}
/**
 * GetSegmentOp retrieves one atom. scope_type/scope_id same as PutSegmentOp.
 *
 * @generated from protobuf message agency.context.v1.GetSegmentOp
 */
export interface GetSegmentOp {
    /**
     * @generated from protobuf field: string scope_type = 1
     */
    scopeType: string;
    /**
     * @generated from protobuf field: string scope_id = 2
     */
    scopeId: string;
    /**
     * @generated from protobuf field: string layer = 3
     */
    layer: string;
    /**
     * @generated from protobuf field: string vertical = 4
     */
    vertical: string;
}
/**
 * GetWsConfigOp retrieves one workspace config value by key.
 *
 * @generated from protobuf message agency.context.v1.GetWsConfigOp
 */
export interface GetWsConfigOp {
    /**
     * @generated from protobuf field: string key = 1
     */
    key: string;
}
/**
 * SetSessionModelOp writes a per-session model_id override. Empty model_id clears it.
 *
 * @generated from protobuf message agency.context.v1.SetSessionModelOp
 */
export interface SetSessionModelOp {
    /**
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * @generated from protobuf field: string model_id = 2
     */
    modelId: string; // empty clears the override
}
/**
 * GetSessionModelOp retrieves the per-session model_id override.
 *
 * @generated from protobuf message agency.context.v1.GetSessionModelOp
 */
export interface GetSessionModelOp {
    /**
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
}
/**
 * CacheBoundary records the byte offset and cumulative content hash at each
 * layer boundary within the assembled system prompt text.
 *
 * @generated from protobuf message agency.context.v1.CacheBoundary
 */
export interface CacheBoundary {
    /**
     * offset is the byte position in the assembled text where this layer ends.
     *
     * @generated from protobuf field: int32 offset = 1
     */
    offset: number;
    /**
     * layer is the layer identifier (e.g. "L0", "L1").
     *
     * @generated from protobuf field: string layer = 2
     */
    layer: string;
    /**
     * cache_key is the cumulative SHA-256 hex digest over all content+version pairs
     * from layer 0 through this layer (inclusive). Covers all prior layers too.
     *
     * @generated from protobuf field: string cache_key = 3
     */
    cacheKey: string;
}
/**
 * ProviderHints contains provider-specific cache optimization metadata
 * derived from CacheBoundary positions by the contextualizer assembler.
 *
 * @generated from protobuf message agency.context.v1.ProviderHints
 */
export interface ProviderHints {
    /**
     * anthropic_breakpoints are byte offsets of the first N layer boundaries
     * for use as Anthropic cache_control: {type: ephemeral} marker positions.
     * Capped by the assembler's max_anthropic_breakpoints config.
     *
     * @generated from protobuf field: repeated int32 anthropic_breakpoints = 1
     */
    anthropicBreakpoints: number[];
    /**
     * stable_prefix_length is the byte offset of the last non-volatile layer boundary.
     * Content before this offset is the stable prefix for OpenAI-style prefix caching.
     * Zero means all layers are volatile (no stable prefix).
     *
     * @generated from protobuf field: int32 stable_prefix_length = 2
     */
    stablePrefixLength: number;
}
/**
 * ContextSkill is a structured injectable context block (lightweight runtime version).
 *
 * @generated from protobuf message agency.context.v1.ContextSkill
 */
export interface ContextSkill {
    /**
     * id uniquely identifies this skill.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * name is the human-readable skill name.
     *
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * content is the skill content (markdown/text).
     *
     * @generated from protobuf field: string content = 3
     */
    content: string;
    /**
     * tags are categorization labels for matching.
     *
     * @generated from protobuf field: repeated string tags = 4
     */
    tags: string[];
    /**
     * categories are primary skill categories.
     *
     * @generated from protobuf field: repeated string categories = 5
     */
    categories: string[];
    /**
     * trust_level is the skill execution trust level.
     *
     * @generated from protobuf field: agency.skill.v1.SkillTrustLevel trust_level = 6
     */
    trustLevel: SkillTrustLevel;
    /**
     * priority affects injection order (higher = earlier).
     *
     * @generated from protobuf field: int32 priority = 7
     */
    priority: number;
    /**
     * enabled indicates if this skill is active.
     *
     * @generated from protobuf field: bool enabled = 8
     */
    enabled: boolean;
}
/**
 * ArtifactReference points to an artifact in Object Store.
 *
 * @generated from protobuf message agency.context.v1.ArtifactReference
 */
export interface ArtifactReference {
    /**
     * artifact_id uniquely identifies the artifact.
     *
     * @generated from protobuf field: string artifact_id = 1
     */
    artifactId: string;
    /**
     * artifact_type describes the artifact (e.g., "corpus", "few_shot_pack").
     *
     * @generated from protobuf field: string artifact_type = 2
     */
    artifactType: string;
    /**
     * object_store_path is the Object Store path.
     *
     * @generated from protobuf field: string object_store_path = 3
     */
    objectStorePath: string;
    /**
     * size_bytes is the artifact size.
     *
     * @generated from protobuf field: int64 size_bytes = 4
     */
    sizeBytes: bigint;
    /**
     * checksum is the artifact content hash (for integrity).
     *
     * @generated from protobuf field: string checksum = 5
     */
    checksum: string;
    /**
     * updated_at is when the artifact was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6
     */
    updatedAt?: Timestamp;
}
/**
 * ContextStageConfig configures a context pipeline stage.
 *
 * @generated from protobuf message agency.context.v1.ContextStageConfig
 */
export interface ContextStageConfig {
    /**
     * stage_name identifies the stage.
     *
     * @generated from protobuf field: string stage_name = 1
     */
    stageName: string;
    /**
     * enabled indicates if this stage is active.
     *
     * @generated from protobuf field: bool enabled = 2
     */
    enabled: boolean;
    /**
     * priority determines execution order (higher = earlier).
     *
     * @generated from protobuf field: int32 priority = 3
     */
    priority: number;
    /**
     * params are stage-specific parameters.
     *
     * @generated from protobuf field: map<string, string> params = 4
     */
    params: {
        [key: string]: string;
    };
    /**
     * timeout is the stage execution timeout.
     *
     * @generated from protobuf field: google.protobuf.Duration timeout = 5
     */
    timeout?: Duration;
}
/**
 * SkillInput is the input to skill sandbox execution.
 *
 * @generated from protobuf message agency.context.v1.SkillInput
 */
export interface SkillInput {
    /**
     * skill_id is the skill to execute.
     *
     * @generated from protobuf field: string skill_id = 1
     */
    skillId: string;
    /**
     * params are skill-specific parameters.
     *
     * @generated from protobuf field: google.protobuf.Struct params = 2
     */
    params?: Struct;
    /**
     * context contains workspace/session context.
     *
     * @generated from protobuf field: map<string, string> context = 3
     */
    context: {
        [key: string]: string;
    };
}
/**
 * SkillOutput is the result of skill execution.
 *
 * @generated from protobuf message agency.context.v1.SkillOutput
 */
export interface SkillOutput {
    /**
     * success indicates if execution succeeded.
     *
     * @generated from protobuf field: bool success = 1
     */
    success: boolean;
    /**
     * result is the execution result.
     *
     * @generated from protobuf field: google.protobuf.Struct result = 2
     */
    result?: Struct;
    /**
     * error_message describes failures.
     *
     * @generated from protobuf field: string error_message = 3
     */
    errorMessage: string;
    /**
     * execution_time_ms is the execution duration.
     *
     * @generated from protobuf field: int64 execution_time_ms = 4
     */
    executionTimeMs: bigint;
    /**
     * logs are execution logs (for debugging).
     *
     * @generated from protobuf field: repeated string logs = 5
     */
    logs: string[];
}
/**
 * ContextStageResult represents the output of a context pipeline stage.
 *
 * @generated from protobuf message agency.context.v1.ContextStageResult
 */
export interface ContextStageResult {
    /**
     * stage_name identifies the stage that produced this result.
     *
     * @generated from protobuf field: string stage_name = 1
     */
    stageName: string;
    /**
     * success indicates if the stage completed successfully.
     *
     * @generated from protobuf field: bool success = 2
     */
    success: boolean;
    /**
     * bundle is the transformed context bundle (if successful).
     *
     * @generated from protobuf field: agency.context.v1.ContextBundle bundle = 3
     */
    bundle?: ContextBundle;
    /**
     * error_message describes stage failure.
     *
     * @generated from protobuf field: string error_message = 4
     */
    errorMessage: string;
    /**
     * execution_time_ms is the stage execution duration.
     *
     * @generated from protobuf field: int64 execution_time_ms = 5
     */
    executionTimeMs: bigint;
    /**
     * completed_at is when the stage completed.
     *
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 6
     */
    completedAt?: Timestamp;
    /**
     * warnings are non-fatal stage warnings.
     *
     * @generated from protobuf field: repeated string warnings = 7
     */
    warnings: string[];
    /**
     * metadata contains stage-specific metadata.
     *
     * @generated from protobuf field: map<string, string> metadata = 8
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * GlobalContextStageResult is the output of the GlobalContextStage.
 *
 * @generated from protobuf message agency.context.v1.GlobalContextStageResult
 */
export interface GlobalContextStageResult {
    /**
     * stage_result is the base stage result.
     *
     * @generated from protobuf field: agency.context.v1.ContextStageResult stage_result = 1
     */
    stageResult?: ContextStageResult;
    /**
     * prompts_loaded is the count of global prompts loaded.
     *
     * @generated from protobuf field: int32 prompts_loaded = 2
     */
    promptsLoaded: number;
    /**
     * skills_loaded is the count of skills loaded.
     *
     * @generated from protobuf field: int32 skills_loaded = 3
     */
    skillsLoaded: number;
    /**
     * artifacts_loaded is the count of artifacts loaded.
     *
     * @generated from protobuf field: int32 artifacts_loaded = 4
     */
    artifactsLoaded: number;
}
/**
 * WorkspaceContextStageResult is the output of the WorkspaceContextStage.
 *
 * @generated from protobuf message agency.context.v1.WorkspaceContextStageResult
 */
export interface WorkspaceContextStageResult {
    /**
     * stage_result is the base stage result.
     *
     * @generated from protobuf field: agency.context.v1.ContextStageResult stage_result = 1
     */
    stageResult?: ContextStageResult;
    /**
     * workspace_config_keys is the count of workspace config keys loaded.
     *
     * @generated from protobuf field: int32 workspace_config_keys = 2
     */
    workspaceConfigKeys: number;
    /**
     * workspace_artifacts is the count of workspace-specific artifacts loaded.
     *
     * @generated from protobuf field: int32 workspace_artifacts = 3
     */
    workspaceArtifacts: number;
}
/**
 * ThreadContextStageResult is the output of the ThreadContextStage.
 *
 * @generated from protobuf message agency.context.v1.ThreadContextStageResult
 */
export interface ThreadContextStageResult {
    /**
     * stage_result is the base stage result.
     *
     * @generated from protobuf field: agency.context.v1.ContextStageResult stage_result = 1
     */
    stageResult?: ContextStageResult;
    /**
     * thread_id is the thread this context came from (if applicable).
     *
     * @generated from protobuf field: string thread_id = 2
     */
    threadId: string;
    /**
     * thread_seed_keys is the count of thread seed keys loaded.
     *
     * @generated from protobuf field: int32 thread_seed_keys = 3
     */
    threadSeedKeys: number;
    /**
     * prior_sessions_count is the count of prior sessions in this thread.
     *
     * @generated from protobuf field: int32 prior_sessions_count = 4
     */
    priorSessionsCount: number;
}
/**
 * SessionContextStageResult is the output of the SessionContextStage.
 *
 * @generated from protobuf message agency.context.v1.SessionContextStageResult
 */
export interface SessionContextStageResult {
    /**
     * stage_result is the base stage result.
     *
     * @generated from protobuf field: agency.context.v1.ContextStageResult stage_result = 1
     */
    stageResult?: ContextStageResult;
    /**
     * session_id is the session this context is for.
     *
     * @generated from protobuf field: string session_id = 2
     */
    sessionId: string;
    /**
     * events_replayed is the count of session events replayed.
     *
     * @generated from protobuf field: int32 events_replayed = 3
     */
    eventsReplayed: number;
    /**
     * snapshot_seq is the stream sequence of the last snapshot (if applicable).
     *
     * @generated from protobuf field: uint64 snapshot_seq = 4
     */
    snapshotSeq: bigint;
}
/**
 * ContextStageTransformRequest invokes a single context stage transform.
 *
 * @generated from protobuf message agency.context.v1.ContextStageTransformRequest
 */
export interface ContextStageTransformRequest {
    /**
     * stage_name identifies the stage to execute.
     *
     * @generated from protobuf field: string stage_name = 1
     */
    stageName: string;
    /**
     * input is the context bundle to transform.
     *
     * @generated from protobuf field: agency.context.v1.ContextBundle input = 2
     */
    input?: ContextBundle;
    /**
     * config is the stage configuration.
     *
     * @generated from protobuf field: agency.context.v1.ContextStageConfig config = 3
     */
    config?: ContextStageConfig;
    /**
     * trace_id links to distributed trace.
     *
     * @generated from protobuf field: string trace_id = 4
     */
    traceId: string;
}
/**
 * ContextStageTransformResponse returns the transformed context bundle.
 *
 * @generated from protobuf message agency.context.v1.ContextStageTransformResponse
 */
export interface ContextStageTransformResponse {
    /**
     * result is the stage execution result.
     *
     * @generated from protobuf field: agency.context.v1.ContextStageResult result = 1
     */
    result?: ContextStageResult;
}
/**
 * ContextPipelineExecutionRequest executes the full context pipeline.
 *
 * @generated from protobuf message agency.context.v1.ContextPipelineExecutionRequest
 */
export interface ContextPipelineExecutionRequest {
    /**
     * tenant is the tenant context.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace context.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * session_id is the session context (optional).
     *
     * @generated from protobuf field: string session_id = 3
     */
    sessionId: string;
    /**
     * thread_id is the thread context (optional).
     *
     * @generated from protobuf field: string thread_id = 4
     */
    threadId: string;
    /**
     * stages are the pipeline stages to execute (in order).
     *
     * @generated from protobuf field: repeated agency.context.v1.ContextStageConfig stages = 5
     */
    stages: ContextStageConfig[];
    /**
     * initial_bundle is the starting context (optional, empty bundle if not provided).
     *
     * @generated from protobuf field: agency.context.v1.ContextBundle initial_bundle = 6
     */
    initialBundle?: ContextBundle;
    /**
     * trace_id links to distributed trace.
     *
     * @generated from protobuf field: string trace_id = 7
     */
    traceId: string;
}
/**
 * ContextPipelineExecutionResponse returns the final assembled context.
 *
 * @generated from protobuf message agency.context.v1.ContextPipelineExecutionResponse
 */
export interface ContextPipelineExecutionResponse {
    /**
     * final_bundle is the output of the full pipeline.
     *
     * @generated from protobuf field: agency.context.v1.ContextBundle final_bundle = 1
     */
    finalBundle?: ContextBundle;
    /**
     * stage_results are the results from each stage (in execution order).
     *
     * @generated from protobuf field: repeated agency.context.v1.ContextStageResult stage_results = 2
     */
    stageResults: ContextStageResult[];
    /**
     * total_execution_time_ms is the wall-clock time for all stages.
     *
     * @generated from protobuf field: int64 total_execution_time_ms = 3
     */
    totalExecutionTimeMs: bigint;
    /**
     * completed_at is when the pipeline completed.
     *
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 4
     */
    completedAt?: Timestamp;
    /**
     * failed_stage is the stage that failed (if any).
     *
     * @generated from protobuf field: string failed_stage = 5
     */
    failedStage: string;
}
/**
 * ContextStageRegistrationRequest registers a custom context stage.
 *
 * @generated from protobuf message agency.context.v1.ContextStageRegistrationRequest
 */
export interface ContextStageRegistrationRequest {
    /**
     * config is the stage configuration.
     *
     * @generated from protobuf field: agency.context.v1.ContextStageConfig config = 1
     */
    config?: ContextStageConfig;
    /**
     * handler_endpoint is the stage execution endpoint (NATS subject or HTTP URL).
     *
     * @generated from protobuf field: string handler_endpoint = 2
     */
    handlerEndpoint: string;
    /**
     * handler_type indicates how to invoke the stage.
     *
     * @generated from protobuf field: agency.context.v1.ContextStageHandlerType handler_type = 3
     */
    handlerType: ContextStageHandlerType;
    /**
     * registered_by identifies who registered this stage.
     *
     * @generated from protobuf field: string registered_by = 4
     */
    registeredBy: string;
}
/**
 * ContextStageRegistrationResponse confirms stage registration.
 *
 * @generated from protobuf message agency.context.v1.ContextStageRegistrationResponse
 */
export interface ContextStageRegistrationResponse {
    /**
     * stage_name is the registered stage identifier.
     *
     * @generated from protobuf field: string stage_name = 1
     */
    stageName: string;
    /**
     * registered_at is when the stage was registered.
     *
     * @generated from protobuf field: google.protobuf.Timestamp registered_at = 2
     */
    registeredAt?: Timestamp;
    /**
     * handler_endpoint is the stage execution endpoint.
     *
     * @generated from protobuf field: string handler_endpoint = 3
     */
    handlerEndpoint: string;
}
/**
 * ContextStageHandlerType defines how stages are invoked.
 *
 * @generated from protobuf enum agency.context.v1.ContextStageHandlerType
 */
export enum ContextStageHandlerType {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: CONTEXT_STAGE_HANDLER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * NATS_REQUEST invokes via NATS request/reply.
     *
     * @generated from protobuf enum value: CONTEXT_STAGE_HANDLER_TYPE_NATS_REQUEST = 1;
     */
    NATS_REQUEST = 1,
    /**
     * HTTP_POST invokes via HTTP POST.
     *
     * @generated from protobuf enum value: CONTEXT_STAGE_HANDLER_TYPE_HTTP_POST = 2;
     */
    HTTP_POST = 2,
    /**
     * IN_PROCESS invokes via registered Go function (internal only).
     *
     * @generated from protobuf enum value: CONTEXT_STAGE_HANDLER_TYPE_IN_PROCESS = 3;
     */
    IN_PROCESS = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class ContextBundle$Type extends MessageType<ContextBundle> {
    constructor() {
        super("agency.context.v1.ContextBundle", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "system_prompt", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "524288" } } } },
            { no: 12, name: "prompts", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "65536" } } } } } },
            { no: 4, name: "skills", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ContextSkill, options: { "buf.validate.field": { repeated: { maxItems: "50" } } } },
            { no: 5, name: "artifacts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ArtifactReference, options: { "buf.validate.field": { repeated: { maxItems: "100" } } } },
            { no: 6, name: "workspace_config", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "100", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "4096" } } } } } },
            { no: 13, name: "thread_seed", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "100", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "32768" } } } } } },
            { no: 7, name: "thread_seed_context", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "32768" } } } },
            { no: 8, name: "model_params", kind: "message", T: () => Struct },
            { no: 9, name: "allowed_tools", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AllowedTool, options: { "buf.validate.field": { repeated: { maxItems: "200" } } } },
            { no: 10, name: "updated_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 11, name: "revision", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 14, name: "cache_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "cache_boundaries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CacheBoundary },
            { no: 16, name: "provider_hints", kind: "message", T: () => ProviderHints },
            { no: 17, name: "ingress_policy", kind: "message", T: () => IngressPolicyConfig, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ContextBundle>): ContextBundle {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.systemPrompt = "";
        message.prompts = {};
        message.skills = [];
        message.artifacts = [];
        message.workspaceConfig = {};
        message.threadSeed = {};
        message.threadSeedContext = "";
        message.allowedTools = [];
        message.revision = 0n;
        message.cacheKey = "";
        message.cacheBoundaries = [];
        if (value !== undefined)
            reflectionMergePartial<ContextBundle>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ContextBundle): ContextBundle {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string system_prompt */ 3:
                    message.systemPrompt = reader.string();
                    break;
                case /* map<string, string> prompts */ 12:
                    this.binaryReadMap12(message.prompts, reader, options);
                    break;
                case /* repeated agency.context.v1.ContextSkill skills */ 4:
                    message.skills.push(ContextSkill.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated agency.context.v1.ArtifactReference artifacts */ 5:
                    message.artifacts.push(ArtifactReference.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* map<string, string> workspace_config */ 6:
                    this.binaryReadMap6(message.workspaceConfig, reader, options);
                    break;
                case /* map<string, string> thread_seed */ 13:
                    this.binaryReadMap13(message.threadSeed, reader, options);
                    break;
                case /* string thread_seed_context */ 7:
                    message.threadSeedContext = reader.string();
                    break;
                case /* google.protobuf.Struct model_params */ 8:
                    message.modelParams = Struct.internalBinaryRead(reader, reader.uint32(), options, message.modelParams);
                    break;
                case /* repeated agency.context.v1.AllowedTool allowed_tools */ 9:
                    message.allowedTools.push(AllowedTool.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp updated_at */ 10:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* uint64 revision */ 11:
                    message.revision = reader.uint64().toBigInt();
                    break;
                case /* string cache_key */ 14:
                    message.cacheKey = reader.string();
                    break;
                case /* repeated agency.context.v1.CacheBoundary cache_boundaries */ 15:
                    message.cacheBoundaries.push(CacheBoundary.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* agency.context.v1.ProviderHints provider_hints */ 16:
                    message.providerHints = ProviderHints.internalBinaryRead(reader, reader.uint32(), options, message.providerHints);
                    break;
                case /* agency.config.v1.IngressPolicyConfig ingress_policy */ 17:
                    message.ingressPolicy = IngressPolicyConfig.internalBinaryRead(reader, reader.uint32(), options, message.ingressPolicy);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap12(map: ContextBundle["prompts"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ContextBundle["prompts"] | undefined, val: ContextBundle["prompts"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.context.v1.ContextBundle.prompts");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    private binaryReadMap6(map: ContextBundle["workspaceConfig"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ContextBundle["workspaceConfig"] | undefined, val: ContextBundle["workspaceConfig"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.context.v1.ContextBundle.workspace_config");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    private binaryReadMap13(map: ContextBundle["threadSeed"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ContextBundle["threadSeed"] | undefined, val: ContextBundle["threadSeed"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.context.v1.ContextBundle.thread_seed");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: ContextBundle, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string system_prompt = 3; */
        if (message.systemPrompt !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.systemPrompt);
        /* repeated agency.context.v1.ContextSkill skills = 4; */
        for (let i = 0; i < message.skills.length; i++)
            ContextSkill.internalBinaryWrite(message.skills[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated agency.context.v1.ArtifactReference artifacts = 5; */
        for (let i = 0; i < message.artifacts.length; i++)
            ArtifactReference.internalBinaryWrite(message.artifacts[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> workspace_config = 6; */
        for (let k of globalThis.Object.keys(message.workspaceConfig))
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.workspaceConfig[k]).join();
        /* string thread_seed_context = 7; */
        if (message.threadSeedContext !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.threadSeedContext);
        /* google.protobuf.Struct model_params = 8; */
        if (message.modelParams)
            Struct.internalBinaryWrite(message.modelParams, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated agency.context.v1.AllowedTool allowed_tools = 9; */
        for (let i = 0; i < message.allowedTools.length; i++)
            AllowedTool.internalBinaryWrite(message.allowedTools[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 10; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* uint64 revision = 11; */
        if (message.revision !== 0n)
            writer.tag(11, WireType.Varint).uint64(message.revision);
        /* map<string, string> prompts = 12; */
        for (let k of globalThis.Object.keys(message.prompts))
            writer.tag(12, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.prompts[k]).join();
        /* map<string, string> thread_seed = 13; */
        for (let k of globalThis.Object.keys(message.threadSeed))
            writer.tag(13, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.threadSeed[k]).join();
        /* string cache_key = 14; */
        if (message.cacheKey !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.cacheKey);
        /* repeated agency.context.v1.CacheBoundary cache_boundaries = 15; */
        for (let i = 0; i < message.cacheBoundaries.length; i++)
            CacheBoundary.internalBinaryWrite(message.cacheBoundaries[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* agency.context.v1.ProviderHints provider_hints = 16; */
        if (message.providerHints)
            ProviderHints.internalBinaryWrite(message.providerHints, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* agency.config.v1.IngressPolicyConfig ingress_policy = 17; */
        if (message.ingressPolicy)
            IngressPolicyConfig.internalBinaryWrite(message.ingressPolicy, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.ContextBundle
 */
export const ContextBundle = new ContextBundle$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AllowedTool$Type extends MessageType<AllowedTool> {
    constructor() {
        super("agency.context.v1.AllowedTool", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_]*[a-z0-9]$" } } } },
            { no: 2, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9_-]*[a-z0-9])?$" } } } }
        ]);
    }
    create(value?: PartialMessage<AllowedTool>): AllowedTool {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.location = "";
        if (value !== undefined)
            reflectionMergePartial<AllowedTool>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AllowedTool): AllowedTool {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string location */ 2:
                    message.location = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AllowedTool, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string location = 2; */
        if (message.location !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.location);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.AllowedTool
 */
export const AllowedTool = new AllowedTool$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScopeAssemblyConfig$Type extends MessageType<ScopeAssemblyConfig> {
    constructor() {
        super("agency.context.v1.ScopeAssemblyConfig", [
            { no: 1, name: "tenant", kind: "message", T: () => ScopeLayerConfig, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "workspace", kind: "message", T: () => ScopeLayerConfig, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "conversation", kind: "message", T: () => ScopeLayerConfig },
            { no: 4, name: "session", kind: "message", T: () => ScopeLayerConfig }
        ]);
    }
    create(value?: PartialMessage<ScopeAssemblyConfig>): ScopeAssemblyConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ScopeAssemblyConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ScopeAssemblyConfig): ScopeAssemblyConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.context.v1.ScopeLayerConfig tenant */ 1:
                    message.tenant = ScopeLayerConfig.internalBinaryRead(reader, reader.uint32(), options, message.tenant);
                    break;
                case /* agency.context.v1.ScopeLayerConfig workspace */ 2:
                    message.workspace = ScopeLayerConfig.internalBinaryRead(reader, reader.uint32(), options, message.workspace);
                    break;
                case /* agency.context.v1.ScopeLayerConfig conversation */ 3:
                    message.conversation = ScopeLayerConfig.internalBinaryRead(reader, reader.uint32(), options, message.conversation);
                    break;
                case /* agency.context.v1.ScopeLayerConfig session */ 4:
                    message.session = ScopeLayerConfig.internalBinaryRead(reader, reader.uint32(), options, message.session);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ScopeAssemblyConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.context.v1.ScopeLayerConfig tenant = 1; */
        if (message.tenant)
            ScopeLayerConfig.internalBinaryWrite(message.tenant, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* agency.context.v1.ScopeLayerConfig workspace = 2; */
        if (message.workspace)
            ScopeLayerConfig.internalBinaryWrite(message.workspace, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* agency.context.v1.ScopeLayerConfig conversation = 3; */
        if (message.conversation)
            ScopeLayerConfig.internalBinaryWrite(message.conversation, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* agency.context.v1.ScopeLayerConfig session = 4; */
        if (message.session)
            ScopeLayerConfig.internalBinaryWrite(message.session, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.ScopeAssemblyConfig
 */
export const ScopeAssemblyConfig = new ScopeAssemblyConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScopeLayerConfig$Type extends MessageType<ScopeLayerConfig> {
    constructor() {
        super("agency.context.v1.ScopeLayerConfig", [
            { no: 1, name: "layers", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "32", items: { string: { minLen: "1", maxLen: "64", pattern: "^[a-zA-Z0-9][a-zA-Z0-9_-]*$" } } } } } },
            { no: 2, name: "volatile_layers", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "32", items: { string: { minLen: "1", maxLen: "64", pattern: "^[a-zA-Z0-9][a-zA-Z0-9_-]*$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<ScopeLayerConfig>): ScopeLayerConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.layers = [];
        message.volatileLayers = [];
        if (value !== undefined)
            reflectionMergePartial<ScopeLayerConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ScopeLayerConfig): ScopeLayerConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string layers */ 1:
                    message.layers.push(reader.string());
                    break;
                case /* repeated string volatile_layers */ 2:
                    message.volatileLayers.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ScopeLayerConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string layers = 1; */
        for (let i = 0; i < message.layers.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.layers[i]);
        /* repeated string volatile_layers = 2; */
        for (let i = 0; i < message.volatileLayers.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.volatileLayers[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.ScopeLayerConfig
 */
export const ScopeLayerConfig = new ScopeLayerConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContextAtomOp$Type extends MessageType<ContextAtomOp> {
    constructor() {
        super("agency.context.v1.ContextAtomOp", [
            { no: 1, name: "put_segment", kind: "message", oneof: "op", T: () => PutSegmentOp },
            { no: 2, name: "delete_segment", kind: "message", oneof: "op", T: () => DeleteSegmentOp },
            { no: 3, name: "put_ws_config", kind: "message", oneof: "op", T: () => PutWsConfigOp },
            { no: 4, name: "put_scope_config", kind: "message", oneof: "op", T: () => PutScopeConfigOp },
            { no: 5, name: "publish_trigger", kind: "message", oneof: "op", T: () => PublishTriggerOp },
            { no: 6, name: "get_segment", kind: "message", oneof: "op", T: () => GetSegmentOp },
            { no: 7, name: "get_ws_config", kind: "message", oneof: "op", T: () => GetWsConfigOp },
            { no: 8, name: "set_session_model", kind: "message", oneof: "op", T: () => SetSessionModelOp },
            { no: 9, name: "get_session_model", kind: "message", oneof: "op", T: () => GetSessionModelOp }
        ]);
    }
    create(value?: PartialMessage<ContextAtomOp>): ContextAtomOp {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.op = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<ContextAtomOp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ContextAtomOp): ContextAtomOp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.context.v1.PutSegmentOp put_segment */ 1:
                    message.op = {
                        oneofKind: "putSegment",
                        putSegment: PutSegmentOp.internalBinaryRead(reader, reader.uint32(), options, (message.op as any).putSegment)
                    };
                    break;
                case /* agency.context.v1.DeleteSegmentOp delete_segment */ 2:
                    message.op = {
                        oneofKind: "deleteSegment",
                        deleteSegment: DeleteSegmentOp.internalBinaryRead(reader, reader.uint32(), options, (message.op as any).deleteSegment)
                    };
                    break;
                case /* agency.context.v1.PutWsConfigOp put_ws_config */ 3:
                    message.op = {
                        oneofKind: "putWsConfig",
                        putWsConfig: PutWsConfigOp.internalBinaryRead(reader, reader.uint32(), options, (message.op as any).putWsConfig)
                    };
                    break;
                case /* agency.context.v1.PutScopeConfigOp put_scope_config */ 4:
                    message.op = {
                        oneofKind: "putScopeConfig",
                        putScopeConfig: PutScopeConfigOp.internalBinaryRead(reader, reader.uint32(), options, (message.op as any).putScopeConfig)
                    };
                    break;
                case /* agency.context.v1.PublishTriggerOp publish_trigger */ 5:
                    message.op = {
                        oneofKind: "publishTrigger",
                        publishTrigger: PublishTriggerOp.internalBinaryRead(reader, reader.uint32(), options, (message.op as any).publishTrigger)
                    };
                    break;
                case /* agency.context.v1.GetSegmentOp get_segment */ 6:
                    message.op = {
                        oneofKind: "getSegment",
                        getSegment: GetSegmentOp.internalBinaryRead(reader, reader.uint32(), options, (message.op as any).getSegment)
                    };
                    break;
                case /* agency.context.v1.GetWsConfigOp get_ws_config */ 7:
                    message.op = {
                        oneofKind: "getWsConfig",
                        getWsConfig: GetWsConfigOp.internalBinaryRead(reader, reader.uint32(), options, (message.op as any).getWsConfig)
                    };
                    break;
                case /* agency.context.v1.SetSessionModelOp set_session_model */ 8:
                    message.op = {
                        oneofKind: "setSessionModel",
                        setSessionModel: SetSessionModelOp.internalBinaryRead(reader, reader.uint32(), options, (message.op as any).setSessionModel)
                    };
                    break;
                case /* agency.context.v1.GetSessionModelOp get_session_model */ 9:
                    message.op = {
                        oneofKind: "getSessionModel",
                        getSessionModel: GetSessionModelOp.internalBinaryRead(reader, reader.uint32(), options, (message.op as any).getSessionModel)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ContextAtomOp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.context.v1.PutSegmentOp put_segment = 1; */
        if (message.op.oneofKind === "putSegment")
            PutSegmentOp.internalBinaryWrite(message.op.putSegment, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* agency.context.v1.DeleteSegmentOp delete_segment = 2; */
        if (message.op.oneofKind === "deleteSegment")
            DeleteSegmentOp.internalBinaryWrite(message.op.deleteSegment, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* agency.context.v1.PutWsConfigOp put_ws_config = 3; */
        if (message.op.oneofKind === "putWsConfig")
            PutWsConfigOp.internalBinaryWrite(message.op.putWsConfig, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* agency.context.v1.PutScopeConfigOp put_scope_config = 4; */
        if (message.op.oneofKind === "putScopeConfig")
            PutScopeConfigOp.internalBinaryWrite(message.op.putScopeConfig, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* agency.context.v1.PublishTriggerOp publish_trigger = 5; */
        if (message.op.oneofKind === "publishTrigger")
            PublishTriggerOp.internalBinaryWrite(message.op.publishTrigger, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* agency.context.v1.GetSegmentOp get_segment = 6; */
        if (message.op.oneofKind === "getSegment")
            GetSegmentOp.internalBinaryWrite(message.op.getSegment, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* agency.context.v1.GetWsConfigOp get_ws_config = 7; */
        if (message.op.oneofKind === "getWsConfig")
            GetWsConfigOp.internalBinaryWrite(message.op.getWsConfig, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* agency.context.v1.SetSessionModelOp set_session_model = 8; */
        if (message.op.oneofKind === "setSessionModel")
            SetSessionModelOp.internalBinaryWrite(message.op.setSessionModel, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* agency.context.v1.GetSessionModelOp get_session_model = 9; */
        if (message.op.oneofKind === "getSessionModel")
            GetSessionModelOp.internalBinaryWrite(message.op.getSessionModel, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.ContextAtomOp
 */
export const ContextAtomOp = new ContextAtomOp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContextAtomResult$Type extends MessageType<ContextAtomResult> {
    constructor() {
        super("agency.context.v1.ContextAtomResult", [
            { no: 1, name: "mutation", kind: "message", oneof: "result", T: () => MutationResult },
            { no: 2, name: "segment", kind: "message", oneof: "result", T: () => GetSegmentResult },
            { no: 3, name: "ws_config", kind: "message", oneof: "result", T: () => GetWsConfigResult },
            { no: 4, name: "error", kind: "scalar", oneof: "result", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "session_model", kind: "message", oneof: "result", T: () => GetSessionModelResult }
        ]);
    }
    create(value?: PartialMessage<ContextAtomResult>): ContextAtomResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.result = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<ContextAtomResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ContextAtomResult): ContextAtomResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.context.v1.MutationResult mutation */ 1:
                    message.result = {
                        oneofKind: "mutation",
                        mutation: MutationResult.internalBinaryRead(reader, reader.uint32(), options, (message.result as any).mutation)
                    };
                    break;
                case /* agency.context.v1.GetSegmentResult segment */ 2:
                    message.result = {
                        oneofKind: "segment",
                        segment: GetSegmentResult.internalBinaryRead(reader, reader.uint32(), options, (message.result as any).segment)
                    };
                    break;
                case /* agency.context.v1.GetWsConfigResult ws_config */ 3:
                    message.result = {
                        oneofKind: "wsConfig",
                        wsConfig: GetWsConfigResult.internalBinaryRead(reader, reader.uint32(), options, (message.result as any).wsConfig)
                    };
                    break;
                case /* string error */ 4:
                    message.result = {
                        oneofKind: "error",
                        error: reader.string()
                    };
                    break;
                case /* agency.context.v1.GetSessionModelResult session_model */ 5:
                    message.result = {
                        oneofKind: "sessionModel",
                        sessionModel: GetSessionModelResult.internalBinaryRead(reader, reader.uint32(), options, (message.result as any).sessionModel)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ContextAtomResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.context.v1.MutationResult mutation = 1; */
        if (message.result.oneofKind === "mutation")
            MutationResult.internalBinaryWrite(message.result.mutation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* agency.context.v1.GetSegmentResult segment = 2; */
        if (message.result.oneofKind === "segment")
            GetSegmentResult.internalBinaryWrite(message.result.segment, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* agency.context.v1.GetWsConfigResult ws_config = 3; */
        if (message.result.oneofKind === "wsConfig")
            GetWsConfigResult.internalBinaryWrite(message.result.wsConfig, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string error = 4; */
        if (message.result.oneofKind === "error")
            writer.tag(4, WireType.LengthDelimited).string(message.result.error);
        /* agency.context.v1.GetSessionModelResult session_model = 5; */
        if (message.result.oneofKind === "sessionModel")
            GetSessionModelResult.internalBinaryWrite(message.result.sessionModel, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.ContextAtomResult
 */
export const ContextAtomResult = new ContextAtomResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MutationResult$Type extends MessageType<MutationResult> {
    constructor() {
        super("agency.context.v1.MutationResult", [
            { no: 1, name: "revision", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<MutationResult>): MutationResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.revision = 0n;
        if (value !== undefined)
            reflectionMergePartial<MutationResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MutationResult): MutationResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 revision */ 1:
                    message.revision = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MutationResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint64 revision = 1; */
        if (message.revision !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.revision);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.MutationResult
 */
export const MutationResult = new MutationResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSegmentResult$Type extends MessageType<GetSegmentResult> {
    constructor() {
        super("agency.context.v1.GetSegmentResult", [
            { no: 1, name: "layer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "vertical", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetSegmentResult>): GetSegmentResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.layer = "";
        message.vertical = "";
        message.content = "";
        message.version = "";
        if (value !== undefined)
            reflectionMergePartial<GetSegmentResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSegmentResult): GetSegmentResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string layer */ 1:
                    message.layer = reader.string();
                    break;
                case /* string vertical */ 2:
                    message.vertical = reader.string();
                    break;
                case /* string content */ 3:
                    message.content = reader.string();
                    break;
                case /* string version */ 4:
                    message.version = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSegmentResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string layer = 1; */
        if (message.layer !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.layer);
        /* string vertical = 2; */
        if (message.vertical !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.vertical);
        /* string content = 3; */
        if (message.content !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.content);
        /* string version = 4; */
        if (message.version !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.version);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.GetSegmentResult
 */
export const GetSegmentResult = new GetSegmentResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetWsConfigResult$Type extends MessageType<GetWsConfigResult> {
    constructor() {
        super("agency.context.v1.GetWsConfigResult", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetWsConfigResult>): GetWsConfigResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.key = "";
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial<GetWsConfigResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetWsConfigResult): GetWsConfigResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                case /* string value */ 2:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetWsConfigResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        /* string value = 2; */
        if (message.value !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.GetWsConfigResult
 */
export const GetWsConfigResult = new GetWsConfigResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSessionModelResult$Type extends MessageType<GetSessionModelResult> {
    constructor() {
        super("agency.context.v1.GetSessionModelResult", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetSessionModelResult>): GetSessionModelResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.modelId = "";
        if (value !== undefined)
            reflectionMergePartial<GetSessionModelResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSessionModelResult): GetSessionModelResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string model_id */ 2:
                    message.modelId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSessionModelResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string model_id = 2; */
        if (message.modelId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.modelId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.GetSessionModelResult
 */
export const GetSessionModelResult = new GetSessionModelResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PutSegmentOp$Type extends MessageType<PutSegmentOp> {
    constructor() {
        super("agency.context.v1.PutSegmentOp", [
            { no: 1, name: "scope_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "scope_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "layer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "vertical", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PutSegmentOp>): PutSegmentOp {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.scopeType = "";
        message.scopeId = "";
        message.layer = "";
        message.vertical = "";
        message.content = "";
        message.version = "";
        if (value !== undefined)
            reflectionMergePartial<PutSegmentOp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PutSegmentOp): PutSegmentOp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string scope_type */ 1:
                    message.scopeType = reader.string();
                    break;
                case /* string scope_id */ 2:
                    message.scopeId = reader.string();
                    break;
                case /* string layer */ 3:
                    message.layer = reader.string();
                    break;
                case /* string vertical */ 4:
                    message.vertical = reader.string();
                    break;
                case /* string content */ 5:
                    message.content = reader.string();
                    break;
                case /* string version */ 6:
                    message.version = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PutSegmentOp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string scope_type = 1; */
        if (message.scopeType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.scopeType);
        /* string scope_id = 2; */
        if (message.scopeId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.scopeId);
        /* string layer = 3; */
        if (message.layer !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.layer);
        /* string vertical = 4; */
        if (message.vertical !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.vertical);
        /* string content = 5; */
        if (message.content !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.content);
        /* string version = 6; */
        if (message.version !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.version);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.PutSegmentOp
 */
export const PutSegmentOp = new PutSegmentOp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteSegmentOp$Type extends MessageType<DeleteSegmentOp> {
    constructor() {
        super("agency.context.v1.DeleteSegmentOp", [
            { no: 1, name: "scope_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "scope_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "layer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "vertical", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteSegmentOp>): DeleteSegmentOp {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.scopeType = "";
        message.scopeId = "";
        message.layer = "";
        message.vertical = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteSegmentOp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteSegmentOp): DeleteSegmentOp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string scope_type */ 1:
                    message.scopeType = reader.string();
                    break;
                case /* string scope_id */ 2:
                    message.scopeId = reader.string();
                    break;
                case /* string layer */ 3:
                    message.layer = reader.string();
                    break;
                case /* string vertical */ 4:
                    message.vertical = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteSegmentOp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string scope_type = 1; */
        if (message.scopeType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.scopeType);
        /* string scope_id = 2; */
        if (message.scopeId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.scopeId);
        /* string layer = 3; */
        if (message.layer !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.layer);
        /* string vertical = 4; */
        if (message.vertical !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.vertical);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.DeleteSegmentOp
 */
export const DeleteSegmentOp = new DeleteSegmentOp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PutWsConfigOp$Type extends MessageType<PutWsConfigOp> {
    constructor() {
        super("agency.context.v1.PutWsConfigOp", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PutWsConfigOp>): PutWsConfigOp {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.key = "";
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial<PutWsConfigOp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PutWsConfigOp): PutWsConfigOp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                case /* string value */ 2:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PutWsConfigOp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        /* string value = 2; */
        if (message.value !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.PutWsConfigOp
 */
export const PutWsConfigOp = new PutWsConfigOp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PutScopeConfigOp$Type extends MessageType<PutScopeConfigOp> {
    constructor() {
        super("agency.context.v1.PutScopeConfigOp", [
            { no: 1, name: "scope_config", kind: "message", T: () => ScopeAssemblyConfig }
        ]);
    }
    create(value?: PartialMessage<PutScopeConfigOp>): PutScopeConfigOp {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PutScopeConfigOp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PutScopeConfigOp): PutScopeConfigOp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.context.v1.ScopeAssemblyConfig scope_config */ 1:
                    message.scopeConfig = ScopeAssemblyConfig.internalBinaryRead(reader, reader.uint32(), options, message.scopeConfig);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PutScopeConfigOp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.context.v1.ScopeAssemblyConfig scope_config = 1; */
        if (message.scopeConfig)
            ScopeAssemblyConfig.internalBinaryWrite(message.scopeConfig, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.PutScopeConfigOp
 */
export const PutScopeConfigOp = new PutScopeConfigOp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PublishTriggerOp$Type extends MessageType<PublishTriggerOp> {
    constructor() {
        super("agency.context.v1.PublishTriggerOp", [
            { no: 1, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PublishTriggerOp>): PublishTriggerOp {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.reason = "";
        message.conversationId = "";
        message.sessionId = "";
        if (value !== undefined)
            reflectionMergePartial<PublishTriggerOp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PublishTriggerOp): PublishTriggerOp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string reason */ 1:
                    message.reason = reader.string();
                    break;
                case /* string conversation_id */ 2:
                    message.conversationId = reader.string();
                    break;
                case /* string session_id */ 3:
                    message.sessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PublishTriggerOp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string reason = 1; */
        if (message.reason !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.reason);
        /* string conversation_id = 2; */
        if (message.conversationId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.conversationId);
        /* string session_id = 3; */
        if (message.sessionId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.PublishTriggerOp
 */
export const PublishTriggerOp = new PublishTriggerOp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSegmentOp$Type extends MessageType<GetSegmentOp> {
    constructor() {
        super("agency.context.v1.GetSegmentOp", [
            { no: 1, name: "scope_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "scope_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "layer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "vertical", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetSegmentOp>): GetSegmentOp {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.scopeType = "";
        message.scopeId = "";
        message.layer = "";
        message.vertical = "";
        if (value !== undefined)
            reflectionMergePartial<GetSegmentOp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSegmentOp): GetSegmentOp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string scope_type */ 1:
                    message.scopeType = reader.string();
                    break;
                case /* string scope_id */ 2:
                    message.scopeId = reader.string();
                    break;
                case /* string layer */ 3:
                    message.layer = reader.string();
                    break;
                case /* string vertical */ 4:
                    message.vertical = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSegmentOp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string scope_type = 1; */
        if (message.scopeType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.scopeType);
        /* string scope_id = 2; */
        if (message.scopeId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.scopeId);
        /* string layer = 3; */
        if (message.layer !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.layer);
        /* string vertical = 4; */
        if (message.vertical !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.vertical);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.GetSegmentOp
 */
export const GetSegmentOp = new GetSegmentOp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetWsConfigOp$Type extends MessageType<GetWsConfigOp> {
    constructor() {
        super("agency.context.v1.GetWsConfigOp", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetWsConfigOp>): GetWsConfigOp {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.key = "";
        if (value !== undefined)
            reflectionMergePartial<GetWsConfigOp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetWsConfigOp): GetWsConfigOp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetWsConfigOp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.GetWsConfigOp
 */
export const GetWsConfigOp = new GetWsConfigOp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetSessionModelOp$Type extends MessageType<SetSessionModelOp> {
    constructor() {
        super("agency.context.v1.SetSessionModelOp", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SetSessionModelOp>): SetSessionModelOp {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.modelId = "";
        if (value !== undefined)
            reflectionMergePartial<SetSessionModelOp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetSessionModelOp): SetSessionModelOp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string model_id */ 2:
                    message.modelId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetSessionModelOp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string model_id = 2; */
        if (message.modelId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.modelId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.SetSessionModelOp
 */
export const SetSessionModelOp = new SetSessionModelOp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSessionModelOp$Type extends MessageType<GetSessionModelOp> {
    constructor() {
        super("agency.context.v1.GetSessionModelOp", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetSessionModelOp>): GetSessionModelOp {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        if (value !== undefined)
            reflectionMergePartial<GetSessionModelOp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSessionModelOp): GetSessionModelOp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSessionModelOp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.GetSessionModelOp
 */
export const GetSessionModelOp = new GetSessionModelOp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CacheBoundary$Type extends MessageType<CacheBoundary> {
    constructor() {
        super("agency.context.v1.CacheBoundary", [
            { no: 1, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "layer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "cache_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CacheBoundary>): CacheBoundary {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.offset = 0;
        message.layer = "";
        message.cacheKey = "";
        if (value !== undefined)
            reflectionMergePartial<CacheBoundary>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CacheBoundary): CacheBoundary {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 offset */ 1:
                    message.offset = reader.int32();
                    break;
                case /* string layer */ 2:
                    message.layer = reader.string();
                    break;
                case /* string cache_key */ 3:
                    message.cacheKey = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CacheBoundary, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 offset = 1; */
        if (message.offset !== 0)
            writer.tag(1, WireType.Varint).int32(message.offset);
        /* string layer = 2; */
        if (message.layer !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.layer);
        /* string cache_key = 3; */
        if (message.cacheKey !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.cacheKey);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.CacheBoundary
 */
export const CacheBoundary = new CacheBoundary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProviderHints$Type extends MessageType<ProviderHints> {
    constructor() {
        super("agency.context.v1.ProviderHints", [
            { no: 1, name: "anthropic_breakpoints", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "stable_prefix_length", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ProviderHints>): ProviderHints {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.anthropicBreakpoints = [];
        message.stablePrefixLength = 0;
        if (value !== undefined)
            reflectionMergePartial<ProviderHints>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProviderHints): ProviderHints {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int32 anthropic_breakpoints */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.anthropicBreakpoints.push(reader.int32());
                    else
                        message.anthropicBreakpoints.push(reader.int32());
                    break;
                case /* int32 stable_prefix_length */ 2:
                    message.stablePrefixLength = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProviderHints, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int32 anthropic_breakpoints = 1; */
        if (message.anthropicBreakpoints.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.anthropicBreakpoints.length; i++)
                writer.int32(message.anthropicBreakpoints[i]);
            writer.join();
        }
        /* int32 stable_prefix_length = 2; */
        if (message.stablePrefixLength !== 0)
            writer.tag(2, WireType.Varint).int32(message.stablePrefixLength);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.ProviderHints
 */
export const ProviderHints = new ProviderHints$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContextSkill$Type extends MessageType<ContextSkill> {
    constructor() {
        super("agency.context.v1.ContextSkill", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "65536" } } } },
            { no: 4, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } },
            { no: 5, name: "categories", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "10", items: { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } },
            { no: 6, name: "trust_level", kind: "enum", T: () => ["agency.skill.v1.SkillTrustLevel", SkillTrustLevel, "SKILL_TRUST_LEVEL_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 7, name: "priority", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100, gte: 0 } } } },
            { no: 8, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ContextSkill>): ContextSkill {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.name = "";
        message.content = "";
        message.tags = [];
        message.categories = [];
        message.trustLevel = 0;
        message.priority = 0;
        message.enabled = false;
        if (value !== undefined)
            reflectionMergePartial<ContextSkill>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ContextSkill): ContextSkill {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string content */ 3:
                    message.content = reader.string();
                    break;
                case /* repeated string tags */ 4:
                    message.tags.push(reader.string());
                    break;
                case /* repeated string categories */ 5:
                    message.categories.push(reader.string());
                    break;
                case /* agency.skill.v1.SkillTrustLevel trust_level */ 6:
                    message.trustLevel = reader.int32();
                    break;
                case /* int32 priority */ 7:
                    message.priority = reader.int32();
                    break;
                case /* bool enabled */ 8:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ContextSkill, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string content = 3; */
        if (message.content !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.content);
        /* repeated string tags = 4; */
        for (let i = 0; i < message.tags.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.tags[i]);
        /* repeated string categories = 5; */
        for (let i = 0; i < message.categories.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.categories[i]);
        /* agency.skill.v1.SkillTrustLevel trust_level = 6; */
        if (message.trustLevel !== 0)
            writer.tag(6, WireType.Varint).int32(message.trustLevel);
        /* int32 priority = 7; */
        if (message.priority !== 0)
            writer.tag(7, WireType.Varint).int32(message.priority);
        /* bool enabled = 8; */
        if (message.enabled !== false)
            writer.tag(8, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.ContextSkill
 */
export const ContextSkill = new ContextSkill$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ArtifactReference$Type extends MessageType<ArtifactReference> {
    constructor() {
        super("agency.context.v1.ArtifactReference", [
            { no: 1, name: "artifact_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "artifact_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 3, name: "object_store_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 4, name: "size_bytes", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 5, name: "checksum", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "32", maxLen: "128" } } } },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ArtifactReference>): ArtifactReference {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.artifactId = "";
        message.artifactType = "";
        message.objectStorePath = "";
        message.sizeBytes = 0n;
        message.checksum = "";
        if (value !== undefined)
            reflectionMergePartial<ArtifactReference>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ArtifactReference): ArtifactReference {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string artifact_id */ 1:
                    message.artifactId = reader.string();
                    break;
                case /* string artifact_type */ 2:
                    message.artifactType = reader.string();
                    break;
                case /* string object_store_path */ 3:
                    message.objectStorePath = reader.string();
                    break;
                case /* int64 size_bytes */ 4:
                    message.sizeBytes = reader.int64().toBigInt();
                    break;
                case /* string checksum */ 5:
                    message.checksum = reader.string();
                    break;
                case /* google.protobuf.Timestamp updated_at */ 6:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ArtifactReference, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string artifact_id = 1; */
        if (message.artifactId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.artifactId);
        /* string artifact_type = 2; */
        if (message.artifactType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.artifactType);
        /* string object_store_path = 3; */
        if (message.objectStorePath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.objectStorePath);
        /* int64 size_bytes = 4; */
        if (message.sizeBytes !== 0n)
            writer.tag(4, WireType.Varint).int64(message.sizeBytes);
        /* string checksum = 5; */
        if (message.checksum !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.checksum);
        /* google.protobuf.Timestamp updated_at = 6; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.ArtifactReference
 */
export const ArtifactReference = new ArtifactReference$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContextStageConfig$Type extends MessageType<ContextStageConfig> {
    constructor() {
        super("agency.context.v1.ContextStageConfig", [
            { no: 1, name: "stage_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 2, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "priority", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "params", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "4096" } } } } } },
            { no: 5, name: "timeout", kind: "message", T: () => Duration }
        ]);
    }
    create(value?: PartialMessage<ContextStageConfig>): ContextStageConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stageName = "";
        message.enabled = false;
        message.priority = 0;
        message.params = {};
        if (value !== undefined)
            reflectionMergePartial<ContextStageConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ContextStageConfig): ContextStageConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stage_name */ 1:
                    message.stageName = reader.string();
                    break;
                case /* bool enabled */ 2:
                    message.enabled = reader.bool();
                    break;
                case /* int32 priority */ 3:
                    message.priority = reader.int32();
                    break;
                case /* map<string, string> params */ 4:
                    this.binaryReadMap4(message.params, reader, options);
                    break;
                case /* google.protobuf.Duration timeout */ 5:
                    message.timeout = Duration.internalBinaryRead(reader, reader.uint32(), options, message.timeout);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap4(map: ContextStageConfig["params"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ContextStageConfig["params"] | undefined, val: ContextStageConfig["params"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.context.v1.ContextStageConfig.params");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: ContextStageConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stage_name = 1; */
        if (message.stageName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stageName);
        /* bool enabled = 2; */
        if (message.enabled !== false)
            writer.tag(2, WireType.Varint).bool(message.enabled);
        /* int32 priority = 3; */
        if (message.priority !== 0)
            writer.tag(3, WireType.Varint).int32(message.priority);
        /* map<string, string> params = 4; */
        for (let k of globalThis.Object.keys(message.params))
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.params[k]).join();
        /* google.protobuf.Duration timeout = 5; */
        if (message.timeout)
            Duration.internalBinaryWrite(message.timeout, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.ContextStageConfig
 */
export const ContextStageConfig = new ContextStageConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SkillInput$Type extends MessageType<SkillInput> {
    constructor() {
        super("agency.context.v1.SkillInput", [
            { no: 1, name: "skill_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "params", kind: "message", T: () => Struct },
            { no: 3, name: "context", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "4096" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SkillInput>): SkillInput {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.skillId = "";
        message.context = {};
        if (value !== undefined)
            reflectionMergePartial<SkillInput>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SkillInput): SkillInput {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string skill_id */ 1:
                    message.skillId = reader.string();
                    break;
                case /* google.protobuf.Struct params */ 2:
                    message.params = Struct.internalBinaryRead(reader, reader.uint32(), options, message.params);
                    break;
                case /* map<string, string> context */ 3:
                    this.binaryReadMap3(message.context, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: SkillInput["context"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SkillInput["context"] | undefined, val: SkillInput["context"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.context.v1.SkillInput.context");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: SkillInput, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string skill_id = 1; */
        if (message.skillId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.skillId);
        /* google.protobuf.Struct params = 2; */
        if (message.params)
            Struct.internalBinaryWrite(message.params, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> context = 3; */
        for (let k of globalThis.Object.keys(message.context))
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.context[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.SkillInput
 */
export const SkillInput = new SkillInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SkillOutput$Type extends MessageType<SkillOutput> {
    constructor() {
        super("agency.context.v1.SkillOutput", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "result", kind: "message", T: () => Struct },
            { no: 3, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } },
            { no: 4, name: "execution_time_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 5, name: "logs", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "100", items: { string: { maxLen: "4096" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SkillOutput>): SkillOutput {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.success = false;
        message.errorMessage = "";
        message.executionTimeMs = 0n;
        message.logs = [];
        if (value !== undefined)
            reflectionMergePartial<SkillOutput>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SkillOutput): SkillOutput {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* google.protobuf.Struct result */ 2:
                    message.result = Struct.internalBinaryRead(reader, reader.uint32(), options, message.result);
                    break;
                case /* string error_message */ 3:
                    message.errorMessage = reader.string();
                    break;
                case /* int64 execution_time_ms */ 4:
                    message.executionTimeMs = reader.int64().toBigInt();
                    break;
                case /* repeated string logs */ 5:
                    message.logs.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SkillOutput, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* google.protobuf.Struct result = 2; */
        if (message.result)
            Struct.internalBinaryWrite(message.result, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string error_message = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        /* int64 execution_time_ms = 4; */
        if (message.executionTimeMs !== 0n)
            writer.tag(4, WireType.Varint).int64(message.executionTimeMs);
        /* repeated string logs = 5; */
        for (let i = 0; i < message.logs.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.logs[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.SkillOutput
 */
export const SkillOutput = new SkillOutput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContextStageResult$Type extends MessageType<ContextStageResult> {
    constructor() {
        super("agency.context.v1.ContextStageResult", [
            { no: 1, name: "stage_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 2, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "bundle", kind: "message", T: () => ContextBundle },
            { no: 4, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } },
            { no: 5, name: "execution_time_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 6, name: "completed_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 7, name: "warnings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { maxLen: "1024" } } } } } },
            { no: 8, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } }
        ]);
    }
    create(value?: PartialMessage<ContextStageResult>): ContextStageResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stageName = "";
        message.success = false;
        message.errorMessage = "";
        message.executionTimeMs = 0n;
        message.warnings = [];
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<ContextStageResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ContextStageResult): ContextStageResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stage_name */ 1:
                    message.stageName = reader.string();
                    break;
                case /* bool success */ 2:
                    message.success = reader.bool();
                    break;
                case /* agency.context.v1.ContextBundle bundle */ 3:
                    message.bundle = ContextBundle.internalBinaryRead(reader, reader.uint32(), options, message.bundle);
                    break;
                case /* string error_message */ 4:
                    message.errorMessage = reader.string();
                    break;
                case /* int64 execution_time_ms */ 5:
                    message.executionTimeMs = reader.int64().toBigInt();
                    break;
                case /* google.protobuf.Timestamp completed_at */ 6:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                case /* repeated string warnings */ 7:
                    message.warnings.push(reader.string());
                    break;
                case /* map<string, string> metadata */ 8:
                    this.binaryReadMap8(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap8(map: ContextStageResult["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ContextStageResult["metadata"] | undefined, val: ContextStageResult["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.context.v1.ContextStageResult.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: ContextStageResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stage_name = 1; */
        if (message.stageName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stageName);
        /* bool success = 2; */
        if (message.success !== false)
            writer.tag(2, WireType.Varint).bool(message.success);
        /* agency.context.v1.ContextBundle bundle = 3; */
        if (message.bundle)
            ContextBundle.internalBinaryWrite(message.bundle, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string error_message = 4; */
        if (message.errorMessage !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.errorMessage);
        /* int64 execution_time_ms = 5; */
        if (message.executionTimeMs !== 0n)
            writer.tag(5, WireType.Varint).int64(message.executionTimeMs);
        /* google.protobuf.Timestamp completed_at = 6; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated string warnings = 7; */
        for (let i = 0; i < message.warnings.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.warnings[i]);
        /* map<string, string> metadata = 8; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(8, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.ContextStageResult
 */
export const ContextStageResult = new ContextStageResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GlobalContextStageResult$Type extends MessageType<GlobalContextStageResult> {
    constructor() {
        super("agency.context.v1.GlobalContextStageResult", [
            { no: 1, name: "stage_result", kind: "message", T: () => ContextStageResult, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "prompts_loaded", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 3, name: "skills_loaded", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 4, name: "artifacts_loaded", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<GlobalContextStageResult>): GlobalContextStageResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.promptsLoaded = 0;
        message.skillsLoaded = 0;
        message.artifactsLoaded = 0;
        if (value !== undefined)
            reflectionMergePartial<GlobalContextStageResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GlobalContextStageResult): GlobalContextStageResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.context.v1.ContextStageResult stage_result */ 1:
                    message.stageResult = ContextStageResult.internalBinaryRead(reader, reader.uint32(), options, message.stageResult);
                    break;
                case /* int32 prompts_loaded */ 2:
                    message.promptsLoaded = reader.int32();
                    break;
                case /* int32 skills_loaded */ 3:
                    message.skillsLoaded = reader.int32();
                    break;
                case /* int32 artifacts_loaded */ 4:
                    message.artifactsLoaded = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GlobalContextStageResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.context.v1.ContextStageResult stage_result = 1; */
        if (message.stageResult)
            ContextStageResult.internalBinaryWrite(message.stageResult, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 prompts_loaded = 2; */
        if (message.promptsLoaded !== 0)
            writer.tag(2, WireType.Varint).int32(message.promptsLoaded);
        /* int32 skills_loaded = 3; */
        if (message.skillsLoaded !== 0)
            writer.tag(3, WireType.Varint).int32(message.skillsLoaded);
        /* int32 artifacts_loaded = 4; */
        if (message.artifactsLoaded !== 0)
            writer.tag(4, WireType.Varint).int32(message.artifactsLoaded);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.GlobalContextStageResult
 */
export const GlobalContextStageResult = new GlobalContextStageResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkspaceContextStageResult$Type extends MessageType<WorkspaceContextStageResult> {
    constructor() {
        super("agency.context.v1.WorkspaceContextStageResult", [
            { no: 1, name: "stage_result", kind: "message", T: () => ContextStageResult, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "workspace_config_keys", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 3, name: "workspace_artifacts", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<WorkspaceContextStageResult>): WorkspaceContextStageResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.workspaceConfigKeys = 0;
        message.workspaceArtifacts = 0;
        if (value !== undefined)
            reflectionMergePartial<WorkspaceContextStageResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkspaceContextStageResult): WorkspaceContextStageResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.context.v1.ContextStageResult stage_result */ 1:
                    message.stageResult = ContextStageResult.internalBinaryRead(reader, reader.uint32(), options, message.stageResult);
                    break;
                case /* int32 workspace_config_keys */ 2:
                    message.workspaceConfigKeys = reader.int32();
                    break;
                case /* int32 workspace_artifacts */ 3:
                    message.workspaceArtifacts = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkspaceContextStageResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.context.v1.ContextStageResult stage_result = 1; */
        if (message.stageResult)
            ContextStageResult.internalBinaryWrite(message.stageResult, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 workspace_config_keys = 2; */
        if (message.workspaceConfigKeys !== 0)
            writer.tag(2, WireType.Varint).int32(message.workspaceConfigKeys);
        /* int32 workspace_artifacts = 3; */
        if (message.workspaceArtifacts !== 0)
            writer.tag(3, WireType.Varint).int32(message.workspaceArtifacts);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.WorkspaceContextStageResult
 */
export const WorkspaceContextStageResult = new WorkspaceContextStageResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ThreadContextStageResult$Type extends MessageType<ThreadContextStageResult> {
    constructor() {
        super("agency.context.v1.ThreadContextStageResult", [
            { no: 1, name: "stage_result", kind: "message", T: () => ContextStageResult, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 3, name: "thread_seed_keys", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 4, name: "prior_sessions_count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<ThreadContextStageResult>): ThreadContextStageResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.threadId = "";
        message.threadSeedKeys = 0;
        message.priorSessionsCount = 0;
        if (value !== undefined)
            reflectionMergePartial<ThreadContextStageResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ThreadContextStageResult): ThreadContextStageResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.context.v1.ContextStageResult stage_result */ 1:
                    message.stageResult = ContextStageResult.internalBinaryRead(reader, reader.uint32(), options, message.stageResult);
                    break;
                case /* string thread_id */ 2:
                    message.threadId = reader.string();
                    break;
                case /* int32 thread_seed_keys */ 3:
                    message.threadSeedKeys = reader.int32();
                    break;
                case /* int32 prior_sessions_count */ 4:
                    message.priorSessionsCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ThreadContextStageResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.context.v1.ContextStageResult stage_result = 1; */
        if (message.stageResult)
            ContextStageResult.internalBinaryWrite(message.stageResult, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string thread_id = 2; */
        if (message.threadId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.threadId);
        /* int32 thread_seed_keys = 3; */
        if (message.threadSeedKeys !== 0)
            writer.tag(3, WireType.Varint).int32(message.threadSeedKeys);
        /* int32 prior_sessions_count = 4; */
        if (message.priorSessionsCount !== 0)
            writer.tag(4, WireType.Varint).int32(message.priorSessionsCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.ThreadContextStageResult
 */
export const ThreadContextStageResult = new ThreadContextStageResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionContextStageResult$Type extends MessageType<SessionContextStageResult> {
    constructor() {
        super("agency.context.v1.SessionContextStageResult", [
            { no: 1, name: "stage_result", kind: "message", T: () => ContextStageResult, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "events_replayed", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 4, name: "snapshot_seq", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<SessionContextStageResult>): SessionContextStageResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.eventsReplayed = 0;
        message.snapshotSeq = 0n;
        if (value !== undefined)
            reflectionMergePartial<SessionContextStageResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SessionContextStageResult): SessionContextStageResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.context.v1.ContextStageResult stage_result */ 1:
                    message.stageResult = ContextStageResult.internalBinaryRead(reader, reader.uint32(), options, message.stageResult);
                    break;
                case /* string session_id */ 2:
                    message.sessionId = reader.string();
                    break;
                case /* int32 events_replayed */ 3:
                    message.eventsReplayed = reader.int32();
                    break;
                case /* uint64 snapshot_seq */ 4:
                    message.snapshotSeq = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SessionContextStageResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.context.v1.ContextStageResult stage_result = 1; */
        if (message.stageResult)
            ContextStageResult.internalBinaryWrite(message.stageResult, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string session_id = 2; */
        if (message.sessionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sessionId);
        /* int32 events_replayed = 3; */
        if (message.eventsReplayed !== 0)
            writer.tag(3, WireType.Varint).int32(message.eventsReplayed);
        /* uint64 snapshot_seq = 4; */
        if (message.snapshotSeq !== 0n)
            writer.tag(4, WireType.Varint).uint64(message.snapshotSeq);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.SessionContextStageResult
 */
export const SessionContextStageResult = new SessionContextStageResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContextStageTransformRequest$Type extends MessageType<ContextStageTransformRequest> {
    constructor() {
        super("agency.context.v1.ContextStageTransformRequest", [
            { no: 1, name: "stage_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 2, name: "input", kind: "message", T: () => ContextBundle, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "config", kind: "message", T: () => ContextStageConfig, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "trace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { pattern: "^([0-9a-f]{32})?$" } } } }
        ]);
    }
    create(value?: PartialMessage<ContextStageTransformRequest>): ContextStageTransformRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stageName = "";
        message.traceId = "";
        if (value !== undefined)
            reflectionMergePartial<ContextStageTransformRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ContextStageTransformRequest): ContextStageTransformRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stage_name */ 1:
                    message.stageName = reader.string();
                    break;
                case /* agency.context.v1.ContextBundle input */ 2:
                    message.input = ContextBundle.internalBinaryRead(reader, reader.uint32(), options, message.input);
                    break;
                case /* agency.context.v1.ContextStageConfig config */ 3:
                    message.config = ContextStageConfig.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                case /* string trace_id */ 4:
                    message.traceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ContextStageTransformRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stage_name = 1; */
        if (message.stageName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stageName);
        /* agency.context.v1.ContextBundle input = 2; */
        if (message.input)
            ContextBundle.internalBinaryWrite(message.input, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* agency.context.v1.ContextStageConfig config = 3; */
        if (message.config)
            ContextStageConfig.internalBinaryWrite(message.config, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string trace_id = 4; */
        if (message.traceId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.traceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.ContextStageTransformRequest
 */
export const ContextStageTransformRequest = new ContextStageTransformRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContextStageTransformResponse$Type extends MessageType<ContextStageTransformResponse> {
    constructor() {
        super("agency.context.v1.ContextStageTransformResponse", [
            { no: 1, name: "result", kind: "message", T: () => ContextStageResult, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ContextStageTransformResponse>): ContextStageTransformResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ContextStageTransformResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ContextStageTransformResponse): ContextStageTransformResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.context.v1.ContextStageResult result */ 1:
                    message.result = ContextStageResult.internalBinaryRead(reader, reader.uint32(), options, message.result);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ContextStageTransformResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.context.v1.ContextStageResult result = 1; */
        if (message.result)
            ContextStageResult.internalBinaryWrite(message.result, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.ContextStageTransformResponse
 */
export const ContextStageTransformResponse = new ContextStageTransformResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContextPipelineExecutionRequest$Type extends MessageType<ContextPipelineExecutionRequest> {
    constructor() {
        super("agency.context.v1.ContextPipelineExecutionRequest", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 4, name: "thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 5, name: "stages", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ContextStageConfig, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "20" } } } },
            { no: 6, name: "initial_bundle", kind: "message", T: () => ContextBundle },
            { no: 7, name: "trace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { pattern: "^([0-9a-f]{32})?$" } } } }
        ]);
    }
    create(value?: PartialMessage<ContextPipelineExecutionRequest>): ContextPipelineExecutionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.sessionId = "";
        message.threadId = "";
        message.stages = [];
        message.traceId = "";
        if (value !== undefined)
            reflectionMergePartial<ContextPipelineExecutionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ContextPipelineExecutionRequest): ContextPipelineExecutionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string session_id */ 3:
                    message.sessionId = reader.string();
                    break;
                case /* string thread_id */ 4:
                    message.threadId = reader.string();
                    break;
                case /* repeated agency.context.v1.ContextStageConfig stages */ 5:
                    message.stages.push(ContextStageConfig.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* agency.context.v1.ContextBundle initial_bundle */ 6:
                    message.initialBundle = ContextBundle.internalBinaryRead(reader, reader.uint32(), options, message.initialBundle);
                    break;
                case /* string trace_id */ 7:
                    message.traceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ContextPipelineExecutionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string session_id = 3; */
        if (message.sessionId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sessionId);
        /* string thread_id = 4; */
        if (message.threadId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.threadId);
        /* repeated agency.context.v1.ContextStageConfig stages = 5; */
        for (let i = 0; i < message.stages.length; i++)
            ContextStageConfig.internalBinaryWrite(message.stages[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* agency.context.v1.ContextBundle initial_bundle = 6; */
        if (message.initialBundle)
            ContextBundle.internalBinaryWrite(message.initialBundle, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string trace_id = 7; */
        if (message.traceId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.traceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.ContextPipelineExecutionRequest
 */
export const ContextPipelineExecutionRequest = new ContextPipelineExecutionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContextPipelineExecutionResponse$Type extends MessageType<ContextPipelineExecutionResponse> {
    constructor() {
        super("agency.context.v1.ContextPipelineExecutionResponse", [
            { no: 1, name: "final_bundle", kind: "message", T: () => ContextBundle, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "stage_results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ContextStageResult },
            { no: 3, name: "total_execution_time_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 4, name: "completed_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "failed_stage", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64" } } } }
        ]);
    }
    create(value?: PartialMessage<ContextPipelineExecutionResponse>): ContextPipelineExecutionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stageResults = [];
        message.totalExecutionTimeMs = 0n;
        message.failedStage = "";
        if (value !== undefined)
            reflectionMergePartial<ContextPipelineExecutionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ContextPipelineExecutionResponse): ContextPipelineExecutionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.context.v1.ContextBundle final_bundle */ 1:
                    message.finalBundle = ContextBundle.internalBinaryRead(reader, reader.uint32(), options, message.finalBundle);
                    break;
                case /* repeated agency.context.v1.ContextStageResult stage_results */ 2:
                    message.stageResults.push(ContextStageResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 total_execution_time_ms */ 3:
                    message.totalExecutionTimeMs = reader.int64().toBigInt();
                    break;
                case /* google.protobuf.Timestamp completed_at */ 4:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                case /* string failed_stage */ 5:
                    message.failedStage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ContextPipelineExecutionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.context.v1.ContextBundle final_bundle = 1; */
        if (message.finalBundle)
            ContextBundle.internalBinaryWrite(message.finalBundle, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated agency.context.v1.ContextStageResult stage_results = 2; */
        for (let i = 0; i < message.stageResults.length; i++)
            ContextStageResult.internalBinaryWrite(message.stageResults[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* int64 total_execution_time_ms = 3; */
        if (message.totalExecutionTimeMs !== 0n)
            writer.tag(3, WireType.Varint).int64(message.totalExecutionTimeMs);
        /* google.protobuf.Timestamp completed_at = 4; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string failed_stage = 5; */
        if (message.failedStage !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.failedStage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.ContextPipelineExecutionResponse
 */
export const ContextPipelineExecutionResponse = new ContextPipelineExecutionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContextStageRegistrationRequest$Type extends MessageType<ContextStageRegistrationRequest> {
    constructor() {
        super("agency.context.v1.ContextStageRegistrationRequest", [
            { no: 1, name: "config", kind: "message", T: () => ContextStageConfig, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "handler_endpoint", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 3, name: "handler_type", kind: "enum", T: () => ["agency.context.v1.ContextStageHandlerType", ContextStageHandlerType, "CONTEXT_STAGE_HANDLER_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 4, name: "registered_by", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<ContextStageRegistrationRequest>): ContextStageRegistrationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.handlerEndpoint = "";
        message.handlerType = 0;
        message.registeredBy = "";
        if (value !== undefined)
            reflectionMergePartial<ContextStageRegistrationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ContextStageRegistrationRequest): ContextStageRegistrationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.context.v1.ContextStageConfig config */ 1:
                    message.config = ContextStageConfig.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                case /* string handler_endpoint */ 2:
                    message.handlerEndpoint = reader.string();
                    break;
                case /* agency.context.v1.ContextStageHandlerType handler_type */ 3:
                    message.handlerType = reader.int32();
                    break;
                case /* string registered_by */ 4:
                    message.registeredBy = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ContextStageRegistrationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.context.v1.ContextStageConfig config = 1; */
        if (message.config)
            ContextStageConfig.internalBinaryWrite(message.config, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string handler_endpoint = 2; */
        if (message.handlerEndpoint !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.handlerEndpoint);
        /* agency.context.v1.ContextStageHandlerType handler_type = 3; */
        if (message.handlerType !== 0)
            writer.tag(3, WireType.Varint).int32(message.handlerType);
        /* string registered_by = 4; */
        if (message.registeredBy !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.registeredBy);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.ContextStageRegistrationRequest
 */
export const ContextStageRegistrationRequest = new ContextStageRegistrationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContextStageRegistrationResponse$Type extends MessageType<ContextStageRegistrationResponse> {
    constructor() {
        super("agency.context.v1.ContextStageRegistrationResponse", [
            { no: 1, name: "stage_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64" } } } },
            { no: 2, name: "registered_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "handler_endpoint", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<ContextStageRegistrationResponse>): ContextStageRegistrationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stageName = "";
        message.handlerEndpoint = "";
        if (value !== undefined)
            reflectionMergePartial<ContextStageRegistrationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ContextStageRegistrationResponse): ContextStageRegistrationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stage_name */ 1:
                    message.stageName = reader.string();
                    break;
                case /* google.protobuf.Timestamp registered_at */ 2:
                    message.registeredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.registeredAt);
                    break;
                case /* string handler_endpoint */ 3:
                    message.handlerEndpoint = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ContextStageRegistrationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stage_name = 1; */
        if (message.stageName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stageName);
        /* google.protobuf.Timestamp registered_at = 2; */
        if (message.registeredAt)
            Timestamp.internalBinaryWrite(message.registeredAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string handler_endpoint = 3; */
        if (message.handlerEndpoint !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.handlerEndpoint);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.context.v1.ContextStageRegistrationResponse
 */
export const ContextStageRegistrationResponse = new ContextStageRegistrationResponse$Type();
